export default {
    Agenda: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "agenda"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Agenda.js
// module id = i+t/
// module chunks = 32